import axiosInstance from 'api/axiosConfig'
import { ENDPOINTS } from 'api/endpoints'

export async function loadAdminUsers() {
  const res = await axiosInstance.get<{ success: boolean; data?: any[] }>(ENDPOINTS.PROPERTY.ADMIN_USERS)
  if (!res.data?.success) throw new Error('Falha ao carregar usuarios')
  return res.data.data ?? []
}

export async function setUserRole(targetUserFk: string, role: string) {
  const res = await axiosInstance.patch<{ success: boolean; message?: string }>(
    ENDPOINTS.PROPERTY.ADMIN_USERS,
    { targetUserFk, role }
  )
  if (!res.data?.success) throw new Error(res.data?.message || 'Falha ao atualizar role')
  return res.data
}

export async function grantSupport(targetUserFk: string) {
  const res = await axiosInstance.post<{ success: boolean; message?: string }>(
    ENDPOINTS.PROPERTY.ADMIN_USERS,
    { action: 'grant-support', targetUserFk }
  )
  if (!res.data?.success) throw new Error(res.data?.message || 'Falha ao conceder suporte')
  return res.data
}

export async function revokeSupport(targetUserFk: string) {
  const res = await axiosInstance.post<{ success: boolean; message?: string }>(
    ENDPOINTS.PROPERTY.ADMIN_USERS,
    { action: 'revoke-support', targetUserFk }
  )
  if (!res.data?.success) throw new Error(res.data?.message || 'Falha ao revogar suporte')
  return res.data
}

export type SupportInvitation = {
  id: number
  email: string
  status: string
  invited_by_user_fk?: string
  accepted_by_user_fk?: string | null
  expires_at: string
  accepted_at?: string | null
  created_at?: string
}

export async function loadSupportInvitations() {
  const res = await axiosInstance.get<{ success: boolean; data?: SupportInvitation[] }>(
    ENDPOINTS.PROPERTY.SUPPORT_INVITATIONS
  )
  if (!res.data?.success) throw new Error('Falha ao carregar convites')
  return res.data.data ?? []
}

export async function inviteSupportByEmail(email: string) {
  const res = await axiosInstance.post<{
    success: boolean
    message?: string
    data?: { email: string; expiresAt: string; emailSent: boolean }
  }>(ENDPOINTS.PROPERTY.SUPPORT_INVITATIONS, { action: 'invite', email })
  if (!res.data?.success) throw new Error(res.data?.message || 'Falha ao enviar convite')
  return res.data
}

export async function revokeSupportInvitation(id: number) {
  const res = await axiosInstance.post<{ success: boolean; message?: string }>(
    ENDPOINTS.PROPERTY.SUPPORT_INVITATIONS,
    { action: 'revoke', id }
  )
  if (!res.data?.success) throw new Error(res.data?.message || 'Falha ao revogar convite')
  return res.data
}

export async function previewSupportInvitation(token: string) {
  const res = await axiosInstance.get<{
    success: boolean
    data?: { email: string; expiresAt: string; status: string }
    message?: string
  }>(ENDPOINTS.PROPERTY.SUPPORT_INVITATIONS, { params: { token } })
  if (!res.data?.success || !res.data.data) {
    throw new Error(res.data?.message || 'Invitation invalide ou expirée')
  }
  return res.data.data
}

export async function acceptSupportInvitation(token: string) {
  const res = await axiosInstance.post<{ success: boolean; message?: string; data?: { role: string } }>(
    ENDPOINTS.PROPERTY.SUPPORT_INVITATIONS,
    { action: 'accept', token }
  )
  if (!res.data?.success) throw new Error(res.data?.message || 'Falha ao aceitar convite')
  return res.data
}

export async function loadContracts() {
  const res = await axiosInstance.get<{ success: boolean; data?: any[] }>(ENDPOINTS.PROPERTY.CONTRACTS)
  if (!res.data?.success) throw new Error('Falha ao carregar contratos')
  return res.data.data ?? []
}

export async function loadBillingCharges() {
  const res = await axiosInstance.get<{ success: boolean; data?: any[] }>(ENDPOINTS.PROPERTY.BILLING_CHARGES)
  if (!res.data?.success) throw new Error('Falha ao carregar cobrancas')
  return res.data.data ?? []
}

export async function loadServiceOffers() {
  const res = await axiosInstance.get<{ success: boolean; data?: any[] }>(ENDPOINTS.PROPERTY.SERVICES_OFFERS)
  if (!res.data?.success) throw new Error('Falha ao carregar ofertas')
  return res.data.data ?? []
}

export async function createServiceOffer(payload: {
  title: string
  category?: string
  description?: string
  basePrice?: number
}) {
  const res = await axiosInstance.post<{ success: boolean; data?: any; message?: string }>(
    ENDPOINTS.PROPERTY.SERVICES_OFFERS,
    payload
  )
  if (!res.data?.success) throw new Error(res.data?.message || 'Falha ao criar oferta')
  return res.data
}

export async function loadServiceOrders() {
  const res = await axiosInstance.get<{ success: boolean; data?: any[] }>(ENDPOINTS.PROPERTY.SERVICES_ORDERS)
  if (!res.data?.success) throw new Error('Falha ao carregar ordens')
  return res.data.data ?? []
}

export async function loadTickets() {
  const res = await axiosInstance.get<{ success: boolean; data?: any[] }>(ENDPOINTS.PROPERTY.SUPPORT_TICKETS)
  if (!res.data?.success) throw new Error('Falha ao carregar tickets')
  return res.data.data ?? []
}

export async function createTicket(payload: { subject: string; message?: string; priority?: string }) {
  const res = await axiosInstance.post<{ success: boolean; data?: any; message?: string }>(
    ENDPOINTS.PROPERTY.SUPPORT_TICKETS,
    payload
  )
  if (!res.data?.success) throw new Error(res.data?.message || 'Falha ao criar ticket')
  return res.data
}

